/**
 * @function capitalize
 * @desc Capitalizes the first letter of a word.
 *
 * @param {String} string - A word to capitalize.
 * @returns {String} A capitalized word.
 */
const capitalize = (string: string = ''): string => {
  if (string !== '') {
    return `${string.charAt(0).toUpperCase()}${string.substring(1)}`;
  }
  return '';
};
export default capitalize;
